import '@/typings/Merchant'
import '@/assets/main.css'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './common/filters'
import router from './router'
import store from './store'
import i18n from './i18n'
import SVGIcon from '@/components/SVGIcon.vue'
import PortalVue from 'portal-vue'
import TinabaAPI from '@/common/TinabaAPI'
import Button from "@/components/Button.vue"
import Image from "@/components/VueImage.vue"
import Loader from "@/components/Loader.vue"
import vClickOutside from 'v-click-outside'
import VueMeta from 'vue-meta'

Vue.use(vClickOutside)
Vue.use(TinabaAPI)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.config.productionTip = false

Vue.component('svg-icon', SVGIcon);
Vue.component('loader', Loader);
Vue.component('app-button', Button);
Vue.component('vue-image', Image);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')